import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet, useLocation } from 'react-router-dom';
import { useScreenSizes } from '@che-ins-ui/theme';
import { removeTrailingSlash } from '@/libs/helpers';
import { Footer } from '../common/Footer';
import { ROUTES } from '../routes';
import { HeaderNavigation } from '../common/HeaderNavigation';
import { Header } from '../common/Header';
import { INSURANCE_DESKTOP_BREAKPOINT } from '../insurance/styles';
export const SearchLayout = () => {
    const { width } = useScreenSizes();
    const { pathname } = useLocation();
    const isAsideNavigationShown = width > INSURANCE_DESKTOP_BREAKPOINT;
    const isInsuranceRoute = removeTrailingSlash(pathname) === ROUTES.order;
    const isHeaderNavigationShown = isInsuranceRoute && !isAsideNavigationShown;
    return (_jsxs("div", { children: [isHeaderNavigationShown ? _jsx(HeaderNavigation, {}) : _jsx(Header, {}), _jsx(Outlet, {}), _jsx(Footer, {})] }));
};
